import React from "react";
import OutsideMeetingNotice from "./OutsideMeetingNotice";


const Loading = (props) => {



  return(
    <>
    {props.appoutofcontext ? (
      <> <OutsideMeetingNotice /></>
    ) : (props.clientType === "android" || props.clientType === "ios") ? (
      <>
       <div className="gac-card gac-warning">
         <div className="gac-title">Not Available on Mobile</div>
          <div className="gac-sub">This app is only supported on Microsoft Teams Desktop or Web.</div>
          <div className="gac-sub">Please re-open it from your computer browser or desktop Teams client.</div>
      </div>

      </>
    ) : (
      <h3 style={{margin:'auto',left:'45%', top:'45%',position:'absolute'}}>Loading...</h3>
    )}
   
    {/* <canvas id="my-canvas" style={{width:'100%',height:'100%'}}></canvas> */}
    {(!props.appoutofcontext && (props.clientType !== "android" && props.clientType !== "ios")) && (
      <div className='loader-container'>
          <div className="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
    </div>
    )}
    
    </>
  );
};

export default Loading;